import Header from "../../../../../components/header";
import { shareURL } from "../../../../../utils/common";
import { useRabbitFestivalContext } from "../../hooks/festival-context";
import RabbitFestivalEventBanner from "./competitions/banner";
import RabbitFestivalEventBottom from "./competitions/bottom";
import RabbitFestivalEventInfo from "./competitions/info";
import RabbitFestivalEventITM from "./competitions/itm";
import RabbitFestivalEventLocation from "./competitions/location";
import RabbitFestivalEventNotice from "./competitions/notice";
import RabbitFestivalEventStructure from "./competitions/structure";
import RabbitFestivalEventSkeleton from "./skeleton";
import { RabbitFestivalEventWrapper } from "./style";

const RabbitFestivalEvent = () => {
  const {
    showHeader,
    setEventId,
    setEvent,
    eventId,
    eventLoading,
    event,
    handleCompetitionPage,
  } = useRabbitFestivalContext();

  const handleShare = () => {
    if (!eventId) return;
    shareURL(`${window.location.href}?event=${eventId}`);
  };

  if (eventLoading) return <RabbitFestivalEventSkeleton />;

  return (
    <RabbitFestivalEventWrapper>
      <Header
        title="RABBIT FESTIVAL"
        show={showHeader}
        img={`/image-web/news/share${showHeader ? "_white" : ""}.svg`}
        back={() => {
          handleCompetitionPage(
            event?.tournament?.competition?.runnerCompetitionId || 0
          );
          setEventId(0);
          setEvent(null);
        }}
        buttonClick={handleShare}
      />
      <RabbitFestivalEventBanner />
      <RabbitFestivalEventInfo />
      <RabbitFestivalEventLocation />
      <RabbitFestivalEventITM />
      <RabbitFestivalEventStructure />
      <RabbitFestivalEventNotice />
      <RabbitFestivalEventBottom />
    </RabbitFestivalEventWrapper>
  );
};

export default RabbitFestivalEvent;
